import { WithSubpages } from '../../subpages';
import { PAGE_TITLE } from '../../consts';
import { merchantPaymentSubpages } from '../../subpages/dictionary';

import { MAIN_PAGE_PATH } from './paths';

const MerchantPayment = () => (
  <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.MERCHANT_PAYMENT} items={merchantPaymentSubpages} />
);

export default MerchantPayment;
